import { type LocationMethod, type MiniLocationMethod } from '../types'

export class ImprintMethodModel {
  static seq = 1
  objectId = ImprintMethodModel.seq++
  decorationMethod = {} as LocationMethod
}

export type MiniImprintMethodModel = {
  decorationMethod: MiniLocationMethod
}
